import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const PrivateRoute = () => {
  // Access the current location object from react-router
  const location = useLocation();

  // Retrieve authentication token from the location state
  const token = location.state?.isAuthenticated;

  // Check if the user is authenticated
  if (token) {
    // Render the nested routes if the user is authenticated
    return <Outlet />;
  } else {
    // Redirect to the login page if the user is not authenticated
    return <Navigate to="/" />;
  }
};

export default PrivateRoute;
